import { Configuration, DefaultApiFactory } from "@leafly-com/reservations-api";
import getConfig from "next/config";

const { publicRuntimeConfig } = getConfig() || {};

export const resApiClient = DefaultApiFactory(
  new Configuration({
    baseOptions: {
      headers: {
        "Content-Type": "application/json",
        "X-Leafly-Id": "web-web",
      },
      withCredentials: true,
    },
  }),
  publicRuntimeConfig.services.reservationsApi.url
);
